import React, {useState} from 'react'
import {Modal, Input, Row, Col, Button, notification } from 'antd'

function CategoryModalNew(props){
    const[nombre, setNombre] = useState("");
    //const [fileList, setFileList] = useState([]);

    const msNotification = (type, title, desc) => {
        notification[type]({
            message: title,
            description:
            desc,
        });
    };

    const handleOk = () => {
        if(nombre !== ""){
            // if(fileList.length > 0){
            //     fileList.forEach(file => {
            //         const reader = new FileReader();
                    
            //         reader.readAsDataURL(file.originFileObj);
            //         reader.onload = ({ target }) => { 
            //             const result = target.result; 
            //             const values = { 
            //                 name: file.name, 
            //                 size: file.size,
            //                 base64Data: result.split(",")[1], 
            //                 type: result.split(";")[0].split(":")[1] 
            //             };
    
            //             const newCategory = {
            //                 image : values.base64Data,
            //                 mediaType : values.type,
            //                 name : values.name,
            //                 categoryName: nombre
            //             }
            //             setNombre("");
            //             setFileList([]);
            //             props.handleOkModalNew(newCategory);
                        
            //         }; 
                    
            //     });
            // }else{
            //     const newCategory = {
            //         image : null,
            //         mediaType : null,
            //         name : null,
            //         categoryName: nombre
            //     }
            //     setNombre("");
            //     props.handleOkModalNew(newCategory);
            // }
            const newCategory = {
                mediaType : null,
                name : null,
                categoryName: nombre
            }
            setNombre("");
            props.handleOkModalNew(newCategory);
            
        }else{
            msNotification('warning', 'Categoría', 'El nombre de la categoría no debe de ser vacio.');
        }
        
      };

    const handleCancel = () => {
        //setFileList([]);
        props.handleCancelModalNew();
    }

    const handleNameChange = (e) => {
        setNombre(e.target.value);
    }

    // const propsUpload = {
    //     onRemove: file => {
    //         const index = fileList.indexOf(file);
    //         const newFileList = fileList.slice();
    //         newFileList.splice(index, 1);
    //         setFileList(newFileList);
         
    //     },
    //     beforeUpload: (newFile ) => {
    //         console.log(newFile)
    //         if (newFile.type === 'image/png' || newFile.type === 'image/jpeg') {
    //             const oldList = [...fileList];
    //             oldList.push(newFile);
    //             setFileList(oldList);
    //             return false;
                
    //           }else{
    //             msNotification('warning', 'Categoría', `${newFile.name} el archivo no es .png o .jpg`);
                
    //           }
    //           return newFile.type === 'image/png' ? false : newFile.type === 'image/jpeg' ? false : Upload.LIST_IGNORE;
            
    //     },
    //     fileList,
    //     listType: "picture-card",
    //     onPreview: file => {
    //         let src = file.url;
    //         if (!src) {
    //           src = new Promise((resolve) => {
    //             const reader = new FileReader();
    //             reader.readAsDataURL(file.originFileObj);
    //             reader.onload = () => resolve(reader.result);
    //           });
    //         }
    //         const image = new Image();
    //         image.src = src;
    //         const imgWindow = window.open(src);
    //         imgWindow.document.write(image.outerHTML);
    //     },
    //     onChange: ({ fileList: newFileList }) => {
    //         setFileList(newFileList);
    //     }
    // };

    return(
        <React.Fragment>
            <Modal title="Nueva Categoria" 
            visible={props.modalVisibleNew} 
            onOk={handleOk} 
            onCancel={handleCancel}
            footer={[
                <Button key="back" onClick={handleCancel}>
                  Cancelar
                </Button>,
                <Button key="submit" type="primary" onClick={handleOk}>
                  Guardar
                </Button>
              ]}>
                <Row>
                    <Col span={24}>
                        <Input value={nombre} onChange={handleNameChange} placeholder="Nombre" />
                    </Col>
                    <Col span={24}>
                        <br/>
                    </Col>
                    {/* <Col span={24}>
                        <Upload {...propsUpload}>
                            {fileList.length < 1 && '+ Upload'}
                        </Upload>
                    </Col> */}
                </Row>
            </Modal>

        </React.Fragment>
    )
}

export default CategoryModalNew;



// WEBPACK FOOTER //
// ./src/components/CategoryModalNew.jsx